import React from "react"
import Layout from "../components/layout/index"
import SEO from "../components/seo"
import BlocoChamadaCadastro from '../components/partials/chamadaCadastro'
import BlocoCoberturas from '../components/partials/coberturas'
import BlocoAssistencias from '../components/partials/assistencias'
import BlocoComoContratar from '../components/partials/comoContratar'
import BlocoFAQ from '../components/partials/faq'
import BlocoPosts from '../components/partials/blogPosts'
import { CTAFold } from "../components/partials/cta-fold"


const IndexPage = () => {

  return (
    <Layout>
      <SEO 
        isHome={true}
        title="Seguro Residencial" 
        description="Agora ficou fácil fazer seguro para imóveis alugados"
        url="/"
        image={'/images/share/square.jpg'}        
      />

      <CTAFold />
      <BlocoChamadaCadastro />
      <BlocoCoberturas />
      <BlocoAssistencias />
      <BlocoComoContratar />
      <BlocoFAQ />
      <BlocoPosts />
    </Layout>
  )
}

export default IndexPage
